
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/futures/contract/spot",
      function () {
        return require("private-next-pages/futures/contract/spot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/futures/contract/spot"])
      });
    }
  